module.exports = __webpack_public_path__ + "static/assets/cb829a2cfd400567d459977c7e3f915b.png";